
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import { getResource, putResource } from '../../../../../../framework/client/resource';
import TextField from '../../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../../framework/fields/SelectField.vue';
import { PurchaseInvoiceRow } from '../../../../../../../common/application/model/PurchaseInvoiceRow';
import SwitchField from '../../../../../../framework/fields/SwitchField.vue';
import IntegerField from '../../../../../../framework/fields/IntegerField.vue';
import CurrencyAmountField from '../../../../../../framework/fields/CurrencyAmountField.vue';
import NumberField from '../../../../../../framework/fields/NumberField.vue';
import PercentageField from '../../../../../../framework/fields/PercentageField.vue';
import DateField from '../../../../../../framework/fields/DateField.vue';
import { ValidationObserver } from 'vee-validate';
import { getDatabaseOptions } from '../../../../../../framework/service/options';
import TextAreaField from '../../../../../../framework/fields/TextAreaField.vue';
import VendorContractSelect from '../../../../../fields/VendorContractSelect.vue';
import { PurchaseInvoice } from '../../../../../../../common/application/model/PurchaseInvoice';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import AutoCompleteField from '../../../../../../framework/fields/AutoCompleteField.vue';
import { successToast, errorToast } from '../../../../../service/toast_service';
import { updateCachedResourceRow } from '../../../../../service/query_cache_service';
import { updatePurchaseInvoiceRow } from '../../../../../../..//browser/application/client/purchase_invoice_client';
import { getVendorContractPrefillData } from '../../../../../client/vehicle_contract_client';
import QuickAddVendorContractModal from '../../../contract/vendor/QuickAddVendorContractModal.vue';
import { VendorContractPrefillResponse } from '../../../../../../../common/application/model/api/VendorContractPrefillResponse';

@Component({
    components: {
        VendorContractSelect,
        TextAreaField,
        DateField,
        PercentageField,
        NumberField,
        CurrencyAmountField,
        SelectField,
        TextField,
        SwitchField,
        IntegerField,
        ValidationObserver,
        AutoCompleteField,
        QuickAddVendorContractModal,
    },
})
export default class EditPurchaseInvoiceRow extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        purchaseInvoice: {} as PurchaseInvoice,
        row: {} as PurchaseInvoiceRow,
        invoiceRowTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    quickAddModalActive = false;
    prefillData: VendorContractPrefillResponse = {} as VendorContractPrefillResponse;

    // Functions
    async mounted() {
        this.local.row = (await getResource<PurchaseInvoiceRow>(this.resourceType, this.id))!!;
        this.local.purchaseInvoice = (await getResource<PurchaseInvoice>(
            ApplicationResource.PURCHASE_INVOICE,
            this.local.row.purchaseInvoiceId,
        ))!!;
        this.local.invoiceRowTypeOptions = await getDatabaseOptions('InvoiceRowType', this);
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    private async saveResource(goBack: boolean) {
        try {
            if (this.local.row.startDate > this.local.row.endDate) {
                throw new Error('Start date cannot be later than end date.');
            }

            const updatedRow = await updatePurchaseInvoiceRow(this.local.row);

            successToast(this, 'message.purchaseInvoiceRowSaved');
            updateCachedResourceRow<PurchaseInvoiceRow>(updatedRow, this.id, this.resourceType);

            if (goBack) {
                this.back();
            }
        } catch (error: any) {
            if (error instanceof Error) {
                errorToast(this, error.message);
            } else {
                errorToast(this, error);
            }
        }
    }

    back() {
        this.$router.go(-1);
    }

    async openQuickAdd() {
        if (!this.local.row.vehicleContractId) {
            errorToast(this, 'message.missingVehicleContract');
            return;
        }

        if (!this.local.row.invoiceRowType) {
            errorToast(this, 'message.missingInvoiceRowType');
            return;
        }
        this.save();
        this.quickAddModalActive = true;
    }

    refresh() {
        this.quickAddModalActive = false;
        window.location.reload();
    }
}
